import { IS_PRODUCTION } from '@repo/common-utils';
import { useUserEventLogger } from '@repo/tracking-service';
import { Button } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

const resetPasswordSsoUrl = `https://sso.${IS_PRODUCTION ? 'prod' : 'dv'}.bznav.com/forgot?client_id=bznav-refund-web`;
export const ForgotPasswordButton = () => {
  const { sendClickEvent } = useUserEventLogger();
  const { push } = useRouter();

  const handleClickForgotPassword = () => {
    sendClickEvent('pw-check_body_forgot');
    push(resetPasswordSsoUrl);
  };

  return (
    <Button.Text type={'button'} onClick={handleClickForgotPassword}>
      비밀번호를 잊으셨나요?
    </Button.Text>
  );
};
